import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class NavigationService {
  private subject = new Subject<any>();

  navigationTo(navLink: string) {
    this.subject.next(navLink);
  }

  navigateToHome() {
    this.subject.next(NAVIGATION_CONST.HOME);
  }

  getCurrentNavigation(): Observable<any> {
    return this.subject.asObservable();
  }
}

export const NAVIGATION_CONST = {
  HOME: "home",
  SUMMARY: "summary",
  EDUCATION: "education",
  PROJECTS: "projects",
  EXPERIENCE: "experience",
  SKILLS: "skills",
  BLOGS: "blogs",
};
